module.exports = __webpack_public_path__ + "static/cafe-paris-logo-081d7fc4597a0b30098e1aa665918088.svg";